module.exports = __webpack_public_path__ + "lendingcircles/resource/App/static/img/mija-app-resource.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mija-app-resource.png
// module id = OI0h
// module chunks = 1